"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.id = id;
exports.isValidSelector = isValidSelector;

function id() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return "".concat(s4()).concat(s4());
}

function isValidSelector(selector) {
  if (!selector) return false;

  var queryCheck = function queryCheck(s) {
    return document.createDocumentFragment().querySelector(s);
  };

  try {
    queryCheck(selector);
  } catch (_unused) {
    return false;
  }

  return true;
}
//# sourceMappingURL=util.js.map